import React from "react";

// Main CRAFT website (static site from craft-main) served full-screen.
// The loyalty platform lives under /loyalty, /c/:slug, /cert/:code etc.
export default function StaticSite() {
  return (
    <iframe
      src="/site.html"
      title="CRAFT Fast Food"
      data-testid="craft-static-site"
      style={{ position: "fixed", inset: 0, width: "100%", height: "100%", border: "none", display: "block" }}
      allow="clipboard-write; geolocation"
    />
  );
}
